import React from 'react';
import {  } from 'prop-types'
import { PropTypes } from "prop-types";
import { connect } from 'react-redux';
import moment from 'moment';

import EditMenu from './EditMenu';

import { List, ListItem } from 'material-ui/List';
import Avatar from 'material-ui/Avatar';
import FlatButton from 'material-ui/FlatButton';
import Checkbox from './Checkbox'
import css from './contactsTable.css';

// Icons
import CommunicationPhone from 'material-ui/svg-icons/communication/phone';
import HardwareSmartphone from 'material-ui/svg-icons/hardware/smartphone';

const getEmailButton = (emails) => {
  let filteredEmails = emails.filter(email => email.email);

  if (!filteredEmails.length) return (
    <FlatButton
      label={' '}
      disabled={true}
    />
  );
  let button = {};

  filteredEmails.forEach(email => {
    if (email.email) {
      button = (
        <a href={`mailto:${email.email}`}>{email.email}</a>
      );
    }}
  );

  return button;
};

const tableStyles = {
  attributes: {
    fontSize: '14px',
  },
  icon: {
    width: '16px',
    height: '16px',
  },
};

function CityStateText({ address }) {
  if (address === null || address === undefined) return <span></span>;

  return (
    <span>
      {
        `${address.city || ''}${address.city ? ', ' : ''}
        ${address.state || ''}`
      }
    </span>
  );
}

// function InfluencerListItem(props) {
//   const { influencer } = props;
//   const colors = ['#F44336', '#00BCD4', '#FF5722', '#795548', '#4CAF50', '#9C27B0'];

//   return (
//     <tr style={{ borderTop: '1px solid #ddd' }}>
//       <td>
//         <Checkbox
//           style={{ marginLeft: 20 }}
//           // onCheck={props.handleChecked.bind(this, influencer.objectID)}
//         />
//       </td>
//       <td className={css.avatar}>
//       {/* <td className={css.avatar} onTouchTap={props.handleViewInfluencerDetails.bind(this, influencer.id)}> */}
//         <Avatar
//           size={50}
//           style={{
//             backgroundColor: colors[influencer.id % colors.length],
//           }}
//           >
//           {influencer.firstName ? influencer.firstName.charAt(0) : ''}
//         </Avatar>
//       </td>
//       <td>
//       {/* <td onTouchTap={props.handleViewInfluencerDetails.bind(this, influencer.id)}> */}
//         <h4 className={css.title}>{`${influencer.firstName || ''} ${influencer.lastName || ''}`}</h4>
//         <p className={css.subtitle}>{influencer.collectiveName}</p>
//         <p className={css.subtitle}>Viewership: {influencer.subscriberCount}</p>
//         <p className={css.subtitle}>
//           <CityStateText address={influencer.address} />
//         </p>
//       </td>
//       <td style={tableStyles.attributes}>{getEmailButton(influencer.emails)} {
//         influencer.emails.filter(email => email.email).length > 1
//         &&
//         <button
//           className={css.emailButton}
//           // onTouchTap={props.handleViewInfluencerDetails.bind(this, influencer.id)}
//         >
//           (+1)
//         </button>
//       }
//       </td>
//       {influencer.phone
//         ?
//         <td style={tableStyles.attributes}>
//           <CommunicationPhone className={css.icon} style={tableStyles.icon}/>
//           <a href={`tel:${influencer.phone}`}>{influencer.phone}</a>
//         </td>
//         :
//         <td></td>
//       }
//       {influencer.mobile
//         ?
//         <td style={tableStyles.attributes}>
//           <HardwareSmartphone className={css.icon} style={tableStyles.icon}/>
//           <a href={`tel:${influencer.mobile}`}>{influencer.mobile}</a>
//         </td>
//         :
//         <td></td>
//       }
//       <td style={tableStyles.attributes}>
//         {moment(influencer.updatedAt).format('MMM Do, YYYY')}
//       </td>
//       <td>
//         <EditMenu
//           handleEdit={props.handlEdit.bind(this, influencer.id)}
//           handleRemove={props.openDeleteWarning.bind(this, influencer.id)}
//         />
//       </td>
//     </tr>
//   );
// }

const TableListItem = ({ item, handleChecked, handlEdit, openDeleteWarning, handleViewDetails, checked, ...props }) => {
  const colors = ['#F44336', '#00BCD4', '#FF5722', '#795548', '#4CAF50', '#9C27B0'];

  const viewDetails = (id, e) => handleViewDetails(item.objectID, e)

  if (typeof item === 'undefined') return null

  return (
    <tr style={{ borderTop: '1px solid #ddd' }}>
      <td>
        <Checkbox checked={checked} onCheck={handleChecked.bind(this, item.objectID)} style={{ marginLeft: '1rem' }} />
      </td>
      {props.avatar &&
        <td className={css.avatar}>
          <Avatar
            size={50}
            style={{
              backgroundColor: colors[parseInt(item.objectID, 10) % colors.length],
            }}
            onTouchTap={viewDetails}
          >
            {item && item.firstName
              ? item.firstName.charAt(0).toLocaleUpperCase()
              : 
              item && item.name
              ?
              item.name.charAt(0).toLocaleUpperCase()
              :
              ''
            }
          </Avatar>
        </td>
      }
      {props.influencer &&
        <td onTouchTap={viewDetails}>
          <h4 className={css.title}>{`${item.firstName || ''} ${item.lastName || ''}`}</h4>
          <p className={css.subtitle}>{item.collective && item.collective.name}</p>
          <p className={css.subtitle}>Viewership: {item.subscriberCount}</p>
          <p className={css.subtitle}>
            <CityStateText address={item.address} />
          </p>
        </td>
      }
      {props.collective &&
        <td onTouchTap={viewDetails}>
          <h4 className={css.title}>{item.name}</h4>
          <p className={css.subtitle}>Influencers: {item.influencersCount}</p>
          <p className={css.subtitle}>{item.parentName}</p>
        </td>
      }
      {props.email &&
        <td style={tableStyles.attributes}>{getEmailButton(item.emails)} {
          item.emails.filter(email => email.email).length > 1
          &&
          <button
            className={css.emailButton}
            onTouchTap={viewDetails}
          >
            (+1)
          </button>
        }
        </td>
      }
      {props.phone && item.phone
        ?
        <td style={tableStyles.attributes}>
          <CommunicationPhone className={css.icon} style={tableStyles.icon} />
          <a href={`tel:${item.phone}`}>{item.phone}</a>
        </td>
        :
        <td></td>
      }
      {props.mobile && item.mobile
        ?
        <td style={tableStyles.attributes}>
          <HardwareSmartphone className={css.icon} style={tableStyles.icon} />
          <a href={`tel:${item.mobile}`}>{item.mobile}</a>
        </td>
        :
        <td></td>
      }
      {props.updatedAt &&
        <td style={tableStyles.attributes}>
          {moment(item.updatedAt).format('MMM Do, YYYY')}
        </td>

      }
      {props.editMenu &&
        <td>
          <EditMenu
            handleEdit={handlEdit.bind(this, item.objectID)}
            handleRemove={openDeleteWarning.bind(this, item.id)}
          />
        </td>
      }
    </tr>
  )
}


TableListItem.PropTypes = {
  avatar: PropTypes.bool,
  influencer: PropTypes.bool,
  email: PropTypes.bool,
  phone: PropTypes.bool,
  mobile: PropTypes.bool,
  editMenu: PropTypes.bool,
  updatedAt: PropTypes.bool,
  item: {
    firstName: PropTypes.string,
    lastName: PropTypes.string,
    objectID: PropTypes.string,
    addresses: PropTypes.array,
    emails: PropTypes.arrayOf(PropTypes.object),
  }
}

export default connect()(TableListItem);
// 


/** WEBPACK FOOTER **
 ** ./components/InfluencerListItem.js
 **/